module.exports = __webpack_public_path__ + "1-29.png?71221f592f227932bc639ce3ee159179";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-29.png
// module id = 106
// module chunks = 0